module.exports = __webpack_public_path__ + "static/filtregif-e4bd911037eadc811011bcd761cf4cfa.gif";